import { AssessmentResponse } from '@/api/api-client';
import { AssessmentViewModel } from '@/api/api-view-models';

export const mapAssessments = (data: AssessmentResponse[]): AssessmentViewModel[] => {
  return data.map(item => ({
    id: item.id,
    name: item.name,
    standard: item.standard,
    standardId: item.standard_id,
    date: item.date,
    scoresChecked: item.scores_checked || false,
    organizationId: item.organization || '',
    gradeSheets: item.grade_sheets || [],
  }))
}
